import { render } from "./DemurrageCalculator.vue?vue&type=template&id=ed4c6bb6&scoped=true"
import script from "./DemurrageCalculator.vue?vue&type=script&lang=js"
export * from "./DemurrageCalculator.vue?vue&type=script&lang=js"

import "./DemurrageCalculator.vue?vue&type=style&index=0&id=ed4c6bb6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4c6bb6"]])

export default __exports__